import { render, staticRenderFns } from "./template.vue?vue&type=template&id=027ed808&scoped=true&"
import script from "@/Components/Global/SideMenu/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/SideMenu/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/SideMenu/style.scss?vue&type=style&index=0&id=027ed808&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027ed808",
  null
  
)

export default component.exports